import GridFiltersBar from './GridFiltersBar';

export default GridFiltersBar;
